import type { SeedProfileFieldsFragment } from '../data/SeedProfileFields.fragment.generated';

function getViewAllUrl(
  seedProfile: SeedProfileFieldsFragment,
): string | undefined {
  const { profileGuid } = seedProfile;

  if (!profileGuid) {
    return undefined;
  }

  return `profiles/${profileGuid}/similar-candidates?isSeedProfileLocationOnly=true`;
}

export default getViewAllUrl;
